import React from 'react'
import infoPkg from "../../../package.json";

const Version = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'development':
      return <>Desenv.</>
    case 'staging':
      return <>{`v${infoPkg.versionHml}`}</>
    case 'production':
      return <>{`v${infoPkg.versionProd}`}</>
    default:
      return <>{`v${infoPkg.version}`}</>
  }
}

export default Version
